import { motion } from 'framer-motion'
import { Wallet } from '@/types'
import { formatCurrency } from '@/lib/utils'
import { EyeOff } from 'lucide-react'

interface WalletCardProps {
  wallet: Wallet
  showBalance: boolean
  delay?: number
}

export function WalletCard({ wallet, showBalance, delay = 0 }: WalletCardProps) {

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      className="bg-white rounded-xl p-4 shadow-sm border border-gray-100"
    >
      <div className="flex items-center justify-between">
        <div className="text-right w-full">
          <div className="flex items-center justify-end space-x-2">
            <span className="text-lg font-bold text-text-primary">
              {showBalance ? formatCurrency(wallet.balance, wallet.currency_code || wallet.currency) : '••••••'}
            </span>
            {!showBalance && <EyeOff className="h-4 w-4 text-text-secondary" />}
          </div>
        </div>
      </div>
    </motion.div>
  )
}















